(function () {
  if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

  const updateDeliveryTime = (sectionId, variant) => {
    if (!sectionId) return;

    const deliveryEl = document.querySelector(`#DeliveryTime-${sectionId}`);
    if (!deliveryEl) return;

    const outOfStockText = deliveryEl.dataset.outOfStock;
    const deliveryText = deliveryEl.dataset.deliveryText;

    if (!variant) {
      deliveryEl.textContent = '';
      return;
    }

    if (!variant.available) {
      deliveryEl.textContent = outOfStockText || '';
      return;
    }

    if (variant.requires_shipping === false) {
      deliveryEl.textContent = '';
      return;
    }

    deliveryEl.textContent = deliveryText || '';
  };

  subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
    const sectionId = event?.data?.sectionId;
    const variant = event?.data?.variant;
    updateDeliveryTime(sectionId, variant);
  });
})();
